// import React from "react";
// import { Box, Paper } from "@mui/material";
// import CustomText from "../CustomText";
// import { useMediaQuery,} from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// const FeatureCard = ({
//   icon,
//   title,
//   description,
//   variant = "light", // 'light' or 'dark'
//   sx,
// }) => {
//         const theme = useTheme();
//   const isLight = variant === "light";
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // e.g. below 600px
//   const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg")); 
//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         px: 4,
//         py:4.5,
//         borderRadius: "2px",
//         backgroundColor: isLight ? "white" : "#002A3F",
//         boxShadow: isLight
//           ? "0px 4px 25px 0px rgba(141, 141, 141, 0.05)"
//           : "0px 4px 25px 0px rgba(0, 0, 0, 0.05)",
//         ...sx,
//       }}
//     >
//       {/* <Box sx={{ mb: 3, mt:1,border:"1.8px solid #D1D3D9",borderRadius:"10px", padding:"8px 6px 6px 6px",width:isMobile?"20%":"20%"}}>
//         {icon}</Box> */}
//         <Box
//   sx={{
//     mb: 3,
//     mt: 1,
//     border: "1.8px solid #D1D3D9",
//     borderRadius: "10px",
//     padding: "8px",
//     width: isMobile ? "60px" : "60px", // fixed square width
//     aspectRatio: "1 / 1",              // keeps it square
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   }}
// >
//   {icon}
// </Box>
//       <CustomText
//         customStyle={{
//           fontSize: "24px",
//           fontWeight: 600,
//           fontFamily: "Poppins, sans-serif",
//           color: isLight ? "#363333" : "white",
//           textAlign: "left",
//           marginBottom: "20px",
//           lineHeight:"1.3"
//         }}
//       >
//         {title}
//       </CustomText>
//       <CustomText
//         style={{
//           fontSize: "16px",
//           fontWeight: 400,
//           fontFamily: "Nunito, sans-serif",
//           color: isLight ? "#868282" : "#E5E5E5",
//           textAlign: "left",
//           marginTop:"13px",
//           lineHeight: "170%",
//         }}
//       >
//         {description}
//       </CustomText>
//     </Paper>
//   );
// };

// export default FeatureCard;



import React from "react";
import { Box, Paper } from "@mui/material";
import CustomText from "../CustomText";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const FeatureCard = ({
  icon,
  title,
  description,
  variant = "light",
  sx,
  showLearnMore = true,
  isComingSoon = false,
}) => {
  const theme = useTheme();
  const isLight = variant === "light";
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  return (
    <Paper
      elevation={0}
      sx={{
        px: 3,
        py: 4,
        borderRadius: "2px",
        border: "1px solid #ddd",
        backgroundColor: isLight ? "white" : "#002A3F",
        boxShadow: isLight
          ? "0px 4px 25px rgba(141, 141, 141, 0.05)"
          : "0px 4px 25px rgba(0, 0, 0, 0.05)",
        minHeight: "400px",
        maxHeight: "420px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        ...sx,
      }}
    >
      {/* Icon */}
      <Box
        sx={{
          mb: 3,
          mt: 1,
          border: "1.8px solid #D1D3D9",
          borderRadius: "10px",
          padding: "8px",
          width: "60px",
          aspectRatio: "1 / 1",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon}
      </Box>

      {/* Title */}
      <CustomText
        customStyle={{
          fontSize: isMobile ? "20px" : "20px",
          fontWeight: 600,
          fontFamily: "Poppins, sans-serif",
          color: isLight ? "#363333" : "white",
          textAlign: "left",
          marginBottom: "12px",
          lineHeight: "1.3",
        }}
      >
        {title}
      </CustomText>

      {/* Description + Learn More */}
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <CustomText
          style={{
            fontSize: "16px",
            fontWeight: 400,
            fontFamily: "Nunito, sans-serif",
            color: isLight ? "#868282" : "#E5E5E5",
            textAlign: "left",
            lineHeight: "1.7",
            display: "-webkit-box",
            WebkitLineClamp: 4,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {description}
        </CustomText>

        {/* Fixed Learn More or Coming Soon */}
        {showLearnMore && !isComingSoon && (
          <Box
            sx={{
              marginTop: "auto",
              pt: 2,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <CustomText
              style={{
                fontSize: "16px",
                fontWeight: 500,
                color: "#0056B3",
                cursor: "pointer",
              }}
            >
              {t("common.learnMore")}
            </CustomText>
          </Box>
        )}

        {/* Coming Soon Badge - Same style and position as Learn More */}
        {isComingSoon && (
          <Box
            sx={{
              marginTop: "auto",
              pt: 2,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <CustomText
              style={{
                fontSize: "16px",
                fontWeight: 500,
                color: "#0056B3",
                cursor: "pointer",
              }}
            >
              {t("common.comingSoon")}
            </CustomText>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default FeatureCard;
